import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import ServiceTypeForm from "./ServiceTypeForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { serviceTypetValidationForm } from "../../utils/validationSchemas";
const CreateServiceType = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(serviceTypetValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <ServiceTypeForm
        errors={errors}
        register={register}
      />
    </FormLayout>
  );
};

export default CreateServiceType;